import React from 'react';

const Bottom1Shape = ({ className }) => {
  return (
    <svg 
      className={className}
      width="573" 
      height="348" 
      viewBox="0 0 573 348" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <path 
        d="M553.277 119.989C575.021 182.823 572.964 373.223 570.694 454.368L396.838 502.115L-141.142 476.582C-127.918 443.035 119.722 370.376 198.52 306.751C245.505 268.813 281.071 208.146 311.617 133.258C344.858 51.76 376.559 11.3999 409.395 3.19797C484.631 -15.5946 534.803 63.6126 553.277 119.989Z" 
        fill="white"
      />
    </svg>
    
  );
};

export default Bottom1Shape;
